import React from 'react';
import PropTypes from 'prop-types';
import { CometaSelectComponent } from '../../../components';
import { Util } from '../../../services';

var CometaSelect = function CometaSelect(_ref) {
  var listName = _ref.listName,
      country = _ref.country,
      language = _ref.language,
      isClearable = _ref.isClearable,
      isCreatable = _ref.isCreatable,
      label = _ref.label,
      handleChange = _ref.handleChange,
      meta = _ref.meta,
      input = _ref.input,
      filterWith = _ref.filterWith,
      sortWith = _ref.sortWith,
      id = _ref.id;
  return React.createElement(CometaSelectComponent, {
    id: id,
    renderOnlySelectComponent: true,
    listName: listName,
    country: country,
    language: language,
    isClearable: isClearable,
    isCreatable: isCreatable,
    label: label,
    handleChange: handleChange,
    meta: meta,
    input: input,
    filterWith: filterWith,
    sortWith: sortWith
  });
};

CometaSelect.propTypes = {
  listName: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  isClearable: PropTypes.bool,
  isCreatable: PropTypes.bool,
  label: PropTypes.node,
  handleChange: PropTypes.func.isRequired,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  filterWith: PropTypes.func,
  sortWith: PropTypes.func
};
CometaSelect.defaultProps = {
  handleChange: Util.noop,
  country: 'INT',
  language: 'en',
  meta: {},
  input: {
    onBlur: Util.noop,
    onFocus: Util.noop,
    onChange: Util.noop
  }
};
export default CometaSelect;